module.exports = __webpack_public_path__ + "img/avatar-empty1.ca608da8.png";